import { IGetSingleArgs, IModuleConfig } from '../interfaces';
import { modules } from '../_config';

interface ModuleService {
  getAllModules(): Promise<IModuleConfig[]>;
  getSingleModule(args: IGetSingleArgs): Promise<IModuleConfig>;
}

const service: ModuleService = {
  async getAllModules() {
    return modules;
  },

  async getSingleModule({ key }: IGetSingleArgs) {
    return modules.filter((m: any) => m.id === key)[0];
  }
};

export default service;
